/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Endpoint_Url_DescriptionInputs */



/**
* | output |
* | --- |
* | "The base URL from your provider's documentation. oneAI detects the server type (vLLM, Ollama, LiteLLM, GreenPT, Mistral, OpenAI and other OpenAI-compatible A..." |
*
* @param {Private_Models_Form_Endpoint_Url_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_endpoint_url_description = /** @type {((inputs?: Private_Models_Form_Endpoint_Url_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Endpoint_Url_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Basis-URL aus der Dokumentation Ihres Anbieters. oneAI erkennt den Servertyp (vLLM, Ollama, LiteLLM, GreenPT, Mistral, OpenAI und andere OpenAI-kompatible APIs).")
	return /** @type {LocalizedString} */ ("The base URL from your provider's documentation. oneAI detects the server type (vLLM, Ollama, LiteLLM, GreenPT, Mistral, OpenAI and other OpenAI-compatible APIs).")
});